import React from "react";
import { StyledCell } from "./index";
import styled from "styled-components";

const StyledGrinchCell = styled(StyledCell)`
    @keyframes scale1 {
        to {
            transform: scale(10);
        }
    }    
    
    @keyframes scale2 {
        to {
            transform: scale(1);
        }
    }
    
    img {
        animation: scale1 2000ms ease-in-out forwards, scale2 2000ms ease-in-out forwards ;
    }
`;

const GrinchCell = () => {
  return (
    <StyledGrinchCell>
      <img src="/grinch.png" alt="grinch" />
    </StyledGrinchCell>
  );
};

export default GrinchCell;
